var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBurger = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "15px",
    className: "header_burger",
    viewBox: "0 0 22 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-323.000000, -56.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(291.000000, 1.750000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.879882813,
    y: 0,
    width: 20.3041992,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.879882813,
    y: 6,
    width: 20.3041992,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.879882813,
    y: 12.036377,
    width: 20.3041992,
    height: 2
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBurger, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/burger.0a668f22.svg";
export { ForwardRef as ReactComponent };